import React, { FC } from 'react';
import { AllieText } from '../../../../components';

export const POField: FC<{ label: string; id: string | undefined }> = ({ label, id }) => {
  return (
    <div>
      <AllieText type="body2" weight={600}>
        {label}: {id ?? '-'}
      </AllieText>
    </div>
  );
};
